<ngx-loading [show]="loading" [config]="{backdropBorderRadius: '14px'}"></ngx-loading>
<h2 mat-dialog-title class="bgDialogHeader text-center">View Attachment
  <div class="pull-right">
    <a class="boxclose" (click)="onNoClick()"></a>
  </div>
</h2>
<mat-dialog-content>
  <mat-tab-group class="p-0">
    <mat-tab label="Fax and E-mail History">
      <table class="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Date Sent</th>
            <th>Sent By</th>
            <th>Sent To</th>
            <th>Type</th>
          </tr>
        </thead>
        <tbody *ngIf="emailFaxData?.length > 0; else noEmailData">
          <tr *ngFor=" let emailFaxData of emailFaxData">
            <td>{{emailFaxData.defTimeStamp}} <br>
              <a (click)="goToLink(emailFaxData.url)">{{emailFaxData.fileName}}</a>
            </td>
            <td>{{emailFaxData.sender}}</td>
            <td>{{emailFaxData.fax}}</td>
            <td>{{emailFaxData.faxType}}</td>
          </tr>
        </tbody>
        <ng-template #noEmailData>
          <tbody>
            <tr>
              <td colspan="4" class="text-center">No data available</td>
            </tr>
          </tbody>
        </ng-template>
      </table>
    </mat-tab>
    <mat-tab label="Attachment">
      <div class="col-md-12 px-0">
        <button (click)="addAttachment()" class="btn btn-success btn-semi-round btn-demo bgBlue pull-right my-1">
          Add Attachment
        </button>
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Attachment &nbsp;&nbsp;
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="Attachments?.length > 0; else noAttachmentData">
            <tr *ngFor="let attachments of Attachments">
              <td><a (click)="goToLink(attachments.fileLink)">{{attachments.fileName}}</a></td>
              <td>{{attachments.description}}</td>
            </tr>
          </tbody>
          <ng-template #noAttachmentData>
            <tbody>
              <tr>
                <td colspan="2" class="text-center">No data available</td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </mat-tab>
    <mat-tab label="Invoices" *ngIf="showInvoiceTab">
      <div class="mt-2">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>Invoices &nbsp;&nbsp;
              </th>
              <th></th>
            </tr>
          </thead>
          <tbody *ngIf="vendorInvoices?.length > 0; else noInvoiceData">
            <tr *ngFor="let invoice of vendorInvoices">
              <td><a (click)="goToLink(invoice.ATTvc255FileLink)">{{invoice.ATTvc255FileName}}</a></td>
              <td>{{invoice.CODvc255Description}}</td>
            </tr>
          </tbody>
          <ng-template #noInvoiceData>
            <tbody>
              <tr>
                <td colspan="2" class="text-center">No data available</td>
              </tr>
            </tbody>
          </ng-template>
        </table>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
